import { ArrowUpRight, Newspaper, Radio, Megaphone, Inbox } from "lucide-react";
import PageHero from "@/components/PageHero";
import { Chapter } from "@/components/Chapter";
import { Reveal } from "@/components/Reveal";
import { PRESS, SOCIAL } from "@/lib/data";

const News = () => (
  <main data-testid="news-page">
    <PageHero
      kicker="News & Press"
      lines={["The Campaign", "In the News"]}
      intro="Latest news and media coverage from Dave's campaign for Attorney General. Radio interviews and event updates will be added here as the campaign travels Delaware."
    />

    <section className="bg-cream py-16 sm:py-24 md:py-28" data-testid="press-coverage-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Chapter kicker="Media Coverage" title="Press & Interviews" />
        <div className="grid md:grid-cols-2 gap-6 mt-12">
          {PRESS.map((p) => (
            <Reveal key={p.url}>
              <a
                href={p.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="news-delawarelive-card"
                className="group flex flex-col h-full bg-white rounded-xl border border-navy/10 shadow-sm hover:shadow-xl transition-all duration-200 hover:-translate-y-1 p-7 sm:p-9"
              >
                <div className="flex items-center justify-between mb-5">
                  <span className="flex items-center gap-2 font-mono text-xs uppercase tracking-[0.25em] text-navy/50">
                    <Newspaper className="w-4 h-4 text-crimson" /> {p.source}
                  </span>
                  <ArrowUpRight className="w-5 h-5 text-navy/30 group-hover:text-crimson transition-colors" />
                </div>
                <h2 className="font-display font-extrabold uppercase tracking-tight text-2xl sm:text-3xl text-navy leading-tight group-hover:text-crimson transition-colors mb-3">
                  {p.title}
                </h2>
                <p className="text-navy/70 text-base leading-relaxed flex-1">{p.summary}</p>
                <p className="font-mono text-xs uppercase tracking-widest text-navy/40 mt-5">{p.date}</p>
              </a>
            </Reveal>
          ))}

          <Reveal delay={0.12}>
            <div className="flex flex-col h-full rounded-xl border-2 border-dashed border-navy/20 p-7 sm:p-9" data-testid="news-more-coming-card">
              <span className="flex items-center gap-2 font-mono text-xs uppercase tracking-[0.25em] text-navy/50 mb-5">
                <Radio className="w-4 h-4 text-crimson" /> On the Air
              </span>
              <h2 className="font-display font-extrabold uppercase tracking-tight text-2xl sm:text-3xl text-navy/60 leading-tight mb-3">
                Radio Interviews Coming Soon
              </h2>
              <p className="text-navy/55 text-base leading-relaxed flex-1">
                Dave is hitting the airwaves across Delaware. Interview links and recordings will be posted here as they air — follow the campaign on Facebook to catch them live.
              </p>
              <a
                href={SOCIAL.facebook}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="news-facebook-follow-link"
                className="mt-5 inline-flex items-center gap-2 font-display font-extrabold uppercase tracking-wider text-lg text-crimson hover:text-crimson-dark transition-colors"
              >
                Follow on Facebook <ArrowUpRight className="w-5 h-5" />
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>

    <section className="bg-navy py-16 sm:py-24" data-testid="press-contact-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-10">
        <Reveal>
          <div className="bg-navy-light/40 border border-cream/10 rounded-xl p-7 sm:p-9 h-full" data-testid="media-contact-card">
            <Megaphone className="w-8 h-8 text-gold mb-5" />
            <h2 className="font-display font-extrabold uppercase tracking-tight text-2xl sm:text-3xl text-cream mb-3">Media Inquiries</h2>
            <p className="text-cream/65 text-base leading-relaxed">
              Members of the press can reach the campaign through the official Facebook page while the campaign press office is being stood up. Media contact details and a downloadable press kit will be published here shortly.
            </p>
          </div>
        </Reveal>
        <Reveal delay={0.12}>
          <div className="bg-navy-light/40 border border-cream/10 rounded-xl p-7 sm:p-9 h-full" data-testid="campaign-statements-card">
            <Inbox className="w-8 h-8 text-gold mb-5" />
            <h2 className="font-display font-extrabold uppercase tracking-tight text-2xl sm:text-3xl text-cream mb-3">Official Statements</h2>
            <p className="text-cream/65 text-base leading-relaxed">
              Campaign announcements, press releases, and official statements from Dave Graham will be posted in this section in reverse-chronological order as they are released.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  </main>
);

export default News;
